var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm-document-upload" },
    [
      _c("csp-base-file-upload", {
        attrs: {
          "file-input-name": "fileUpload",
          "show-help-text": false,
          "upload-error-message": _vm.$t("record document upload error"),
          "upload-url": _vm.uploadUrl,
        },
        on: {
          "before-upload": _vm.handleBeforeUpload,
          "upload-complete": _vm.handleUploadComplete,
          "upload-error": function ($event) {
            return _vm.$emit("upload-error")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }